import type { ReactNode } from 'react';

interface CardProps {
  readonly title?: ReactNode;
  readonly description?: ReactNode;
  readonly actions?: ReactNode;
  readonly children?: ReactNode;
  readonly className?: string;
}

export function Card({ title, description, actions, children, className }: CardProps) {
  return (
    <section className={['qr-card', className].filter(Boolean).join(' ')}>
      {(title || actions) && (
        <header className="qr-card__head">
          <div>
            {title ? <h2 className="qr-card__title">{title}</h2> : null}
            {description ? <p className="qr-card__description">{description}</p> : null}
          </div>
          {actions ? <div className="qr-card__actions">{actions}</div> : null}
        </header>
      )}
      {children}
    </section>
  );
}
